import { io, type Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '@hitster/shared';

/**
 * Typisierter Socket. Ein Singleton, weil die App genau eine
 * Verbindung braucht und diese auch Routenwechsel ueberleben soll.
 */
export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: AppSocket | null = null;

export function getSocket(): AppSocket {
  if (socket) return socket;

  socket = io({
    // Im Dev-Betrieb proxied Vite /socket.io an den Server, in Produktion
    // ist es derselbe Origin. Also nie eine absolute URL setzen.
    path: '/socket.io',
    // Cookies muessen mitgehen, daran haengt die Spotify-Session.
    withCredentials: true,
    // Polling als Fallback erlauben: manche Firmen-/Mobilfunknetze
    // blockieren Websockets.
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
  });

  return socket;
}

// ---------------------------------------------------------------------------
// Wiedereinstieg
// ---------------------------------------------------------------------------

const RESUME_KEY = 'hitster.resume';

export interface ResumeInfo {
  code: string;
  playerId: string;
  resumeToken: string;
}

/** Merkt sich die Sitzung, damit ein Reload nicht aus dem Spiel wirft. */
export function saveResume(info: ResumeInfo): void {
  localStorage.setItem(RESUME_KEY, JSON.stringify(info));
}

export function loadResume(): ResumeInfo | null {
  const raw = localStorage.getItem(RESUME_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ResumeInfo;
    if (!parsed.code || !parsed.resumeToken) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearResume(): void {
  localStorage.removeItem(RESUME_KEY);
}
